(() => {
  const nav = document.querySelector('[data-dd-mega-menu]');

  if (!nav) return;

  const items = nav.querySelectorAll('.dd-mega-nav__item');
  const headerShell = nav.closest('.dd-header-shell');
  let closeTimer;

  const closeAll = () => {
    window.clearTimeout(closeTimer);
    items.forEach((item) => {
      const topLink = item.querySelector('.dd-mega-nav__top-link');

      item.classList.remove('dd-mega-nav__item--open');

      if (topLink) {
        topLink.setAttribute('aria-expanded', 'false');
      }
    });

    if (headerShell) {
      headerShell.classList.remove('dd-header-shell--menu-open');
    }
  };

  const scheduleClose = () => {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(closeAll, 140);
  };

  items.forEach((item) => {
    const topLink = item.querySelector('.dd-mega-nav__top-link');
    const panel = item.querySelector('[data-dd-mega-panel]');

    if (!topLink || !panel) return;

    topLink.setAttribute('aria-haspopup', 'true');
    topLink.setAttribute('aria-expanded', 'false');

    item.addEventListener('mouseenter', () => {
      window.clearTimeout(closeTimer);
      closeAll();
      item.classList.add('dd-mega-nav__item--open');
      topLink.setAttribute('aria-expanded', 'true');

      if (headerShell) {
        headerShell.classList.add('dd-header-shell--menu-open');
      }
    });

    item.addEventListener('mouseleave', () => {
      scheduleClose();
    });

    panel.addEventListener('mouseenter', () => {
      window.clearTimeout(closeTimer);
      item.classList.add('dd-mega-nav__item--open');
      topLink.setAttribute('aria-expanded', 'true');
    });

    panel.addEventListener('mouseleave', () => {
      scheduleClose();
    });

    item.addEventListener('focusin', () => {
      window.clearTimeout(closeTimer);
      closeAll();
      item.classList.add('dd-mega-nav__item--open');
      topLink.setAttribute('aria-expanded', 'true');

      if (headerShell) {
        headerShell.classList.add('dd-header-shell--menu-open');
      }
    });

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) {
        scheduleClose();
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
